import isEmpty from 'lodash/isEmpty'
export interface Config {
  fields: {
    birthdate: boolean
    email: boolean
    phone: boolean
  }
  selector: string
  success: {
    title: string
    description: string
  }
}

interface injectModuleParams {
  description: string
  selector: string
  title: string
}

const generateForm = async (config: Config): Promise<boolean> => {
  const promise: Promise<boolean> = new Promise((resolve) => {
    if (isEmpty(config)) {
      resolve(false)
      return
    }

    const { birthdate, email, phone } = config.fields
    const { description, title } = config.success
    const selector = config.selector

    if (!birthdate && email && phone) {
      resolve(injectModule8({ description, selector, title }))
      return
    }

    if (birthdate && email && !phone) {
      resolve(injectModule7({ description, selector, title }))
      return
    }

    resolve(false)
  })

  return await promise
}

const injectModule7 = async (params: injectModuleParams) => {
  return await window.ExposedRayBanApi.injectRegistrationModule({
    excerpt: params.description,
    moduleNumber: 7,
    selector: params.selector,
    title: params.title,
  })
}

const injectModule8 = async (params: injectModuleParams) => {
  return await window.ExposedRayBanApi.injectRegistrationModule({
    excerpt: params.description,
    moduleNumber: 8,
    selector: params.selector,
    title: params.title,
  })
}

export const registerGenerateForm = () => {
  window.generateForm = generateForm
}
